import { memo, useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { EVENT_CONTEXT } from "modules/event/eventView/EventViewContext";
import { useJoinEvent } from "modules/joinEvent";
import { selectCurrentEventId } from "modules/event/selectors";
import { selectDirectTableLink } from "modules/conversation/hooks/useCopyTableLink/selectors";
import { reset } from "modules/conversation/hooks/useCopyTableLink/slice";
import { useAppDispatch } from "store/hooks";
import { selectNetworkIsConnected } from "modules/network/redux/selectors";

export const JoinRoomEffects = memo(() => {
  const isConnected = useSelector(selectNetworkIsConnected);
  const { eventCompanyPlan } = useContext(EVENT_CONTEXT);
  const joinEventFired = useRef(false);
  const eventId = useSelector(selectCurrentEventId);
  const { joinEvent } = useJoinEvent();
  const { tableId, floorId } = useSelector(selectDirectTableLink);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isConnected && eventCompanyPlan && eventId && !joinEventFired.current) {
      joinEvent({
        eventId,
        tableId,
        floorId,
      });
      joinEventFired.current = true;
      dispatch(reset());
    }
  }, [
    dispatch,
    eventCompanyPlan,
    eventId,
    floorId,
    isConnected,
    joinEvent,
    tableId,
  ]);

  return null;
});
